import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import Create from '../crud/create'
import menuItems from './menuItems'
import api from '../../api'
import omit from 'lodash/omit'

const fields = [
  { name: 'Name', prop: 'name', type: 'text' },
  {
    name: 'Session',
    prop: 'session_id',
    type: 'autocomplete',
    references: 'admin/sessions',
    referenceProp: 'name',
    displayProp: 'long_name',
    rejectCustomValues: true
  },
  {
    name: 'Group',
    prop: 'group_id',
    type: 'autocomplete',
    references: 'admin/groups',
    referenceProp: 'name',
    displayProp: 'name',
    rejectCustomValues: true
  },
  [
    { name: 'Start Date', prop: 'start_date', type: 'date' },
    { name: 'End Date', prop: 'end_date', type: 'date' }
  ]
]

class CopyCommentBot extends Component<any, any> {
  componentWillMount () {
    this.getResource()
  }

  constructor (props) {
    super(props)
    this.state = {
      resource: null
    }
  }

  getResource () {
    const path = `admin/comment_bots/${this.props.params.commentBotId}`

    return api
      .get(path)
      .then(res => {
        if (res.status === 200) {
          res.json().then(resource => {
            // Add " Copy" suffix to the name
            this.setState({
              resource: Object.assign({}, omit(resource, 'id'), {
                name: `${resource.name} Copy`
              })
            })
          })
        } else {
          browserHistory.push('/write-now/comment-bots')
        }
      })
  }

  render () {
    return (
      <Create
        title='Copying Comment Bot'
        fields={fields}
        apiPath={`admin/comment_bots/${this.props.params.commentBotId}/copy`}
        successRedirectPath={resource => `/write-now/comment-bots/${resource.id}/edit`}
        buildMenuItems={menuItems}
        resource={this.state.resource}
      />
    )
  }
}

export default CopyCommentBot
